import { useSelector } from 'react-redux';
import { useItemTags } from '../hooks/useItemTags';
import lock from '../img/icons/lock.svg';
import { getContrastingTextColor } from '../helpers/colourUtils';
import { useMemo } from 'react';

const getLoyaltyTagText = (tag, itemId, loyaltyScheme) => {
    const isPicollo = itemId === '10000007311';
    const isRomana = itemId === '27';
    const lowerCaseTag = tag.toLowerCase();

    switch (loyaltyScheme) {
        case 2:
            switch (lowerCaseTag) {
                case 'bronze':
                    if (isPicollo) return '- 25% off';
                    return 'Reward';
                case 'silver':
                    if (isPicollo) return '- 50% off';
                    if (isRomana) return 'Reward - Free Romana Upgrade';
                    return 'Reward';
                case 'gold':
                    if (isPicollo) return '- Free';
                    if (isRomana) return 'Reward - Free Romana Upgrade';
                    return 'Reward';
                default:
                    return 'Reward';
            }
        default:
            switch (lowerCaseTag) {
                case 'gold':
                    if (isRomana) return 'Reward - Free Romana Upgrade';
                    return 'Reward';
                default:
                    return 'Reward';
            }
    }
}

export const Tags = ({ item, isBundle = false, currentTier, loyaltySchemeVersion, showLocked, excludeChildTags, showLowerBirthdayTiers = false, wrapperClass, outOfStockOverride = false, outOfStockDisabled = false }) => {
    const { loyaltyTags, birthdayTags, uiTags, lockedBDayTags, lockedLoyaltyTags, hasTags } = useItemTags(item, isBundle, currentTier, loyaltySchemeVersion, showLocked, excludeChildTags, showLowerBirthdayTiers);
    const loyaltyScheme = useSelector(state => state.loyalty?.customer?.loyaltySchemeVersion);

    if (!hasTags && !item?.outOfStock && !outOfStockOverride) return null;

    const renderedTags = useMemo(() => {
        return <div className={wrapperClass}>
            {
                (item?.outOfStock || outOfStockOverride) && !outOfStockDisabled ?
                    <div className='ui-tag outofstock'>
                        Out of stock
                    </div>
                    : null
            }
            {birthdayTags?.length > 0 &&
                birthdayTags.map(tag => (<div key={'birthdayTag' + tag} data-testid={`tag-birthday-${tag}`} className={`tag ui-tag ${tag.toLowerCase()}`}>Birthday&nbsp;Treat</div>))}
            {loyaltyTags?.length > 0 &&
                loyaltyTags.map(tag => (<div key={'loyaltyTags' + tag} data-testid={`tag-tier-reward-tag-${tag}`} className={`tag ui-tag ${tag.toLowerCase()}`}>{tag}&nbsp;{getLoyaltyTagText(tag, item.id, loyaltyScheme)}</div>))}
            {lockedBDayTags?.length > 0 &&
                lockedBDayTags.map(tag => (<div key={'lockedBDayTags' + tag} data-testid={`tag-birthday-${tag}-locked`} className={`tag ui-tag ${tag.toLowerCase()} locked`}> Birthday Treat <img alt="locked" src={lock} className="icon is-small" style={{ width: 24 }} /> </div>))}
            {lockedLoyaltyTags?.length > 0 &&
                lockedLoyaltyTags.map(tag => (<div key={'lockedLoyaltyTags' + tag} data-testid={`tag-tier-reward-tag-${tag}-locked`} className={`tag ui-tag ${tag.toLowerCase()} locked`}>{tag}&nbsp;{getLoyaltyTagText(tag, item.id, loyaltyScheme)} <img alt="locked" src={lock} className="icon is-small" style={{ width: 24 }} /> </div>))}
            {!isBundle && uiTags?.length > 0 &&
                uiTags.map(tag => (<div key={'uiTags' + tag} data-testid={`tag-ui-${tag}`} className={`tag ui-tag new`}>{tag.startsWith('#') ? tag.slice(1) : tag}</div>))}
            {isBundle && uiTags?.length > 0 &&
                uiTags.map(tag => {
                    const textColor = getContrastingTextColor(tag.colour);
                    return (
                        <div
                            key={'uiTags' + tag.name}
                            data-testid={`tag-ui-${tag.name}`}
                            style={{
                                backgroundColor: tag.colour,
                                color: textColor,
                            }}
                            className="tag ui-tag"
                        >
                            {tag.name}
                        </div>
                    );
                })}
        </div>
    }, [item, isBundle, currentTier, loyaltySchemeVersion, showLocked, excludeChildTags, showLowerBirthdayTiers, wrapperClass, outOfStockOverride, outOfStockDisabled]);

    return renderedTags;
}